import { render, staticRenderFns } from "./HolidaySettings.vue?vue&type=template&id=4f74f831&scoped=true&"
import script from "./HolidaySettings.vue?vue&type=script&lang=js&"
export * from "./HolidaySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f74f831",
  null
  
)

export default component.exports